/* eslint-ignore */

// Environment variables for the admin app in packages/admin
export const admin = {
    development: {
        AWS_APP_CLIENT_ID: '5lj4l3rdgd1j7fsk1pgjan6pgh',
        AWS_IDENTITY_POOL_ID: 'us-east-1:c5d62b51-5f61-44ce-af9f-ffc3fa53646d',
        AWS_LOGS_BUCKET: 'trqk-eventbridge-log',
        AWS_REGION: 'us-east-1',
        AWS_USER_POOL_ID: 'us-east-1_9JXUGvheR',
    },
    production: {
        AWS_APP_CLIENT_ID: '5lj4l3rdgd1j7fsk1pgjan6pgh',
        AWS_IDENTITY_POOL_ID: 'us-east-1:c5d62b51-5f61-44ce-af9f-ffc3fa53646d',
        AWS_LOGS_BUCKET: 'trqk-eventbridge-log',
        AWS_REGION: 'us-east-1',
        AWS_USER_POOL_ID: 'us-east-1_9JXUGvheR',
    },
    staging: {
        AWS_APP_CLIENT_ID: '5lj4l3rdgd1j7fsk1pgjan6pgh',
        AWS_IDENTITY_POOL_ID: 'us-east-1:c5d62b51-5f61-44ce-af9f-ffc3fa53646d',
        AWS_LOGS_BUCKET: 'trqk-eventbridge-log',
        AWS_REGION: 'us-east-1',
        AWS_USER_POOL_ID: 'us-east-1_9JXUGvheR',
    },
};
// Environment variables for the web app in packages/web
export const web = {
    development: {
        AMCHARTS_LICENSE_CHARTS: 'CH233879874',
        AMCHARTS_LICENSE_MAPS: 'MP233879874',
        AWS_APP_CLIENT_ID: '3oqehjv77ij7h4p1ng8b7h6a0f',
        AWS_COGNITO_IDP_URL: 'https://cognito-idp.us-east-1.amazonaws.com/',
        AWS_COGNITO_IDENTITY_URL:
            'https://cognito-identity.us-east-1.amazonaws.com/',
        AWS_IDENTITY_POOL_ID: 'us-east-1:c5d62b51-5f61-44ce-af9f-ffc3fa53646d',
        AWS_REGION: 'us-east-1',
        AWS_S3_GAP_DETECTION_UPLOADS_BUCKET: 'trqk-gap-detection-uploads-dev',
        AWS_S3_LOGS_BUCKET: 'trqk-client-log-dev',
        AWS_S3_PRO_STATEMENT_BUCKET: 'trqk-pro-statements-dev',
        AWS_S3_USER_AUDIO_FILES_BUCKET: 'trqk-user-audio-files-dev',
        AWS_S3_USER_IMAGES_BUCKET: 'trqk-web-user-images-dev',
        AWS_USER_POOL_ID: 'us-east-1_9LuiEA12P',
        INVITATIONS_URL: 'https://kraftwerk.trqk.io',
        INVITATION_LIST_URL:
            'https://r4b2tstda3.execute-api.us-east-1.amazonaws.com/dev',
        LOG_ROCKET_APP_ID: 'vgtw2q/trqk-web-development',
        PRO_INGESTION_V2_URL:
            'https://6upvn3ptgk.execute-api.us-east-1.amazonaws.com/dev/proStatementInfo',
        PRO_STATEMENT_VIEW_URL:
            'https://1l3uqx0wd2.execute-api.us-east-1.amazonaws.com/merge/',
        PRO_STATEMENT_VIEW_VERSION: '1.3',
        REGISTER_INVITED_USER_URL:
            'https://d4n5f1ojug.execute-api.us-east-1.amazonaws.com/dev',
        TRQK_DIRECTORY_URL:
            'https://lwpsps5nmff2jjndq4x53ge3wi.appsync-api.us-east-1.amazonaws.com/graphql',
    },
    staging: {
        AMCHARTS_LICENSE_CHARTS: 'CH233879874',
        AMCHARTS_LICENSE_MAPS: 'MP233879874',
        AWS_APP_CLIENT_ID: '3knpfs96bih5qkqrkrhh979uef',
        AWS_COGNITO_IDP_URL: 'https://cognito-idp.us-east-1.amazonaws.com/',
        AWS_COGNITO_IDENTITY_URL:
            'https://cognito-identity.us-east-1.amazonaws.com/',
        AWS_IDENTITY_POOL_ID: 'us-east-1:90b6531e-b58c-4fb9-869e-5d8bc3a5dc78',
        AWS_REGION: 'us-east-1',
        AWS_S3_GAP_DETECTION_UPLOADS_BUCKET:
            'trqk-gap-detection-uploads-staging',
        AWS_S3_LOGS_BUCKET: 'trqk-client-log-staging',
        AWS_S3_PRO_STATEMENT_BUCKET: 'trqk-pro-statements-staging',
        AWS_S3_USER_AUDIO_FILES_BUCKET: 'trqk-user-audio-files-staging',
        AWS_S3_USER_IMAGES_BUCKET: 'trqk-web-user-images-staging',
        AWS_USER_POOL_ID: 'us-east-1_4irKROa0V',
        INVITATIONS_URL: 'https://kraftwerk.trqk.io',
        INVITATION_LIST_URL:
            'https://r4b2tstda3.execute-api.us-east-1.amazonaws.com/dev',
        LOG_ROCKET_APP_ID: 'vgtw2q/trqk-web-staging',
        PRO_INGESTION_V2_URL:
            'https://6upvn3ptgk.execute-api.us-east-1.amazonaws.com/staging/proStatementInfo',
        PRO_STATEMENT_VIEW_URL:
            'https://1l3uqx0wd2.execute-api.us-east-1.amazonaws.com/staging',
        PRO_STATEMENT_VIEW_VERSION: '1.3',
        REGISTER_INVITED_USER_URL:
            'https://d940g60rei.execute-api.us-east-1.amazonaws.com/staging',
        TRQK_DIRECTORY_URL:
            'https://iodgc5ibvreqjbsgdwmtogjpfy.appsync-api.us-east-1.amazonaws.com/graphql',
    },
    production: {
        AMCHARTS_LICENSE_CHARTS: 'CH233879874',
        AMCHARTS_LICENSE_MAPS: 'MP233879874',
        AWS_APP_CLIENT_ID: '7g6j0upj293jbias8hmf0ub3hv',
        AWS_COGNITO_IDP_URL: 'https://cognito-idp.us-east-1.amazonaws.com/',
        AWS_COGNITO_IDENTITY_URL:
            'https://cognito-identity.us-east-1.amazonaws.com/',
        AWS_IDENTITY_POOL_ID: 'us-east-1:1fcfcefb-fffd-4221-91bd-01608261b859',
        AWS_REGION: 'us-east-1',
        AWS_S3_GAP_DETECTION_UPLOADS_BUCKET: 'trqk-gap-detection-uploads-prod',
        AWS_S3_LOGS_BUCKET: 'trqk-client-log-prod',
        AWS_S3_PRO_STATEMENT_BUCKET: 'trqk-pro-statements-prod',
        AWS_S3_USER_AUDIO_FILES_BUCKET: 'trqk-user-audio-files-prod',
        AWS_S3_USER_IMAGES_BUCKET: 'trqk-web-user-images-prod',
        AWS_USER_POOL_ID: 'us-east-1_z86IyJoYQ',
        INVITATIONS_URL: 'https://kraftwerk.trqk.io',
        INVITATION_LIST_URL:
            'https://r4b2tstda3.execute-api.us-east-1.amazonaws.com/dev',
        LOG_ROCKET_APP_ID: 'vgtw2q/trqk-web-production',
        PRO_INGESTION_V2_URL:
            'https://6upvn3ptgk.execute-api.us-east-1.amazonaws.com/prod/proStatementInfo',
        PRO_STATEMENT_VIEW_URL:
            'https://1l3uqx0wd2.execute-api.us-east-1.amazonaws.com/prod',
        PRO_STATEMENT_VIEW_VERSION: '1.3',
        REGISTER_INVITED_USER_URL:
            'https://swvlrgp0jg.execute-api.us-east-1.amazonaws.com/prod',
        TRQK_DIRECTORY_URL:
            'https://h3bailxmurey7pxamnwmcmh5j4.appsync-api.us-east-1.amazonaws.com/graphql',
    },
};
